import actions from '../../actionTypes';

export default (siteId, queryParams) => {
  return {
    type: actions.EXPORT_TAG_LIST,
    siteId,
    queryParams
  };
};


// WEBPACK FOOTER //
// ./src/reducers/tags/actions/downloadTagList.js